export default (elem) => {
    const body = document.body;
    const menuButton = elem.querySelector('.site-header__menu-toggle');

    if (menuButton) {
      menuButton.addEventListener('click', () => {
        if (body.classList.contains('nav-open')) {
          body.classList.remove('nav-open');
        } else {
          body.classList.add('nav-open');
        }
      });
    }
}